import Button from '@app/components/button';
import { T } from '@app/components/translation';

type Props = {
  onClick: (() => void) | undefined;
  aTagClassName: string;
};

const OverdueOwner = ({ onClick, aTagClassName }: Props) => (
  <>
    <span>
      <b>
        <T
          _str="Document is overdue."
          _comment="Text for overdue contract from owner view. Visible in contract."
        />
      </b>{' '}
      <T
        _str="To enable signing, extend the signing period."
        _comment="Text for overdue contract from owner view. Visible in contract."
      />
    </span>
    <Button
      kind="linkInline"
      onClick={onClick}
      customClass={aTagClassName}
    >
      <T
        _str="Document settings"
        _comment="Link to Document settings"
      />
    </Button>
  </>
);

export default OverdueOwner;
